import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedDTO } from 'src/app/Common/common.interface';
import { StudentAdmissionCreateRequestDTO, StudentAdmissionDTO, StudentAdmissionUpdateRequestDTO, StudentAdmissionList, StudentAdmissionDeleteRequestDTO, StudentAdmissionReadByIdRequestDTO, StudentAdmissionReadByClassIdRequestDTO, StudentAdmissionReadBySchoolIdRequestDTO, StudentAdmissionReadBySUserIdRequestDTO, StudentAdmissionBulkUniversal, StudentAdmissionBulkResponse, StudentAdmissionApproveRequestDTO } from './student-admission.interface';
import { StudentAdmission_Create, StudentAdmission_Update, StudentAdmission_ReadAll, StudentAdmission_Delete, StudentAdmission_ReadByClassId, StudentAdmission_ReadBySchoolId, StudentAdmission_ReadBySUserId, StudentAdmission_ReadById, StudentAdmission_AdmissionList, SStudentAdmission_ValidateBulk, SStudentAdmission_CreateBulk, StudentAdmission_AdmissionApprove, StudentAdmission_ExternalCreate } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class StudentAdmissionService {

  constructor() { }

  http = inject(HttpClient)


  StudentAdmission_Create(data: StudentAdmissionCreateRequestDTO): Observable<StudentAdmissionDTO> {
    return this.http.post<StudentAdmissionDTO>(StudentAdmission_Create, data)
  }

  StudentAdmission_ExternalCreate(
      data: StudentAdmissionCreateRequestDTO,
      xApiKey: string,
      xApiTimestamp: string,
      xApiNonce: string,
      xApiSignature: string
    ): Observable<StudentAdmissionDTO> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Api-Key': xApiKey,
        'X-Api-Timestamp': xApiTimestamp,
        'X-Api-Nonce': xApiNonce,
        'X-Api-Signature': xApiSignature
      });
      return this.http.post<StudentAdmissionDTO>(StudentAdmission_ExternalCreate, data, { headers });
    }

  StudentAdmission_Update(data: StudentAdmissionUpdateRequestDTO): Observable<StudentAdmissionDTO> {
    return this.http.post<StudentAdmissionDTO>(StudentAdmission_Update, data)
  }

  StudentAdmission_ReadAll(): Observable<StudentAdmissionList> {
    return this.http.get<StudentAdmissionList>(StudentAdmission_ReadAll)
  }

  StudentAdmission_Delete(data: StudentAdmissionDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(StudentAdmission_Delete, data)
  }

  StudentAdmission_ReadByClassId(data: StudentAdmissionReadByClassIdRequestDTO): Observable<StudentAdmissionList> {
    return this.http.post<StudentAdmissionList>(StudentAdmission_ReadByClassId, data)
  }

  StudentAdmission_ReadBySchoolId(data: StudentAdmissionReadBySchoolIdRequestDTO): Observable<StudentAdmissionList> {
    return this.http.post<StudentAdmissionList>(StudentAdmission_ReadBySchoolId, data)
  }

   StudentAdmission_ReadBySUserId(data: StudentAdmissionReadBySUserIdRequestDTO): Observable<StudentAdmissionDTO> {
    return this.http.post<StudentAdmissionDTO>(StudentAdmission_ReadBySUserId, data)
  }

  StudentAdmission_ReadById(data: StudentAdmissionReadByIdRequestDTO): Observable<StudentAdmissionDTO> {
    return this.http.post<StudentAdmissionDTO>(StudentAdmission_ReadById, data)
  }
  StudentAdmission_ValidateBulk(data: StudentAdmissionBulkUniversal): Observable<StudentAdmissionBulkResponse> {
  return this.http.post<StudentAdmissionBulkResponse>(SStudentAdmission_ValidateBulk, data);
}

StudentAdmission_CreateBulk(data: StudentAdmissionBulkUniversal): Observable<StudentAdmissionBulkResponse> {
  return this.http.post<StudentAdmissionBulkResponse>(SStudentAdmission_CreateBulk, data);
}

StudentAdmission_AdmissionApprove(
  data: StudentAdmissionApproveRequestDTO
): Observable<StudentAdmissionDTO> {
  return this.http.post<StudentAdmissionDTO>(
    StudentAdmission_AdmissionApprove,
    data
  );
}

}
